import { Form, Input, } from 'antd'
import TextArea from 'antd/es/input/TextArea';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';

function TagsForm({ onFinish, editingTags, setEditingTags, form }) {
    const { t } = useTranslation();

    useEffect(() => {
        if (editingTags) {
            form.setFieldsValue(editingTags);
        } else {
            form.resetFields();
        }
    }, [editingTags]);

    return (
        <div>
            <Form
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                form={form}
                onFinish={onFinish}
                requiredMark="optional"
            >
                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("tag_name_pattern_msg"),
                            pattern: /^(?=.{1,30}$)[a-zA-Z ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("vd_pt_Tags_n")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="tag_name"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("tag_name_arabic_pattern_msg"),
                            pattern: /^[\u0600-\u06FF ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("vd_pt_Tags_n")} {t("in Arabic")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="tag_name_ar"
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("tag_description_pattern_msg"),
                            pattern: /^[a-zA-Z ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("Description")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="tag_description"
                >
                    <TextArea />
                </Form.Item>

                <Form.Item
                    rules={[
                        {
                            required: true,
                            message: t("tag_description_arabic_pattern_msg"),
                            pattern: /^[\u0600-\u06FF ,.'-]+$/i,
                        },
                    ]}
                    label={
                        <span className="flex items-center gap-1">
                            {t("Description")} {t("in Arabic")}
                            <span className="text-red-500">*</span>
                        </span>
                    }
                    name="tag_description_ar"
                >
                    <TextArea />
                </Form.Item>

                <button
                    className="btn btn-primary w-full rounded-md text-white"
                    type="submit"
                >
                    {editingTags ? t("Update") : t("vd_pc_btn")}
                </button>
            </Form>
        </div>
    )
}

export default TagsForm;
